module.exports = __webpack_public_path__ + "static/media/arrow_button.f78c9ed2.svg";